import { render, staticRenderFns } from "./userEdit.vue?vue&type=template&id=5c2305d0&"
import script from "./userEdit.vue?vue&type=script&lang=ts&"
export * from "./userEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports